import { render, staticRenderFns } from "./ContentApprovalOnboardingDrawer.vue?vue&type=template&id=1107aad5&scoped=true&"
import script from "./ContentApprovalOnboardingDrawer.vue?vue&type=script&lang=js&"
export * from "./ContentApprovalOnboardingDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ContentApprovalOnboardingDrawer.vue?vue&type=style&index=0&id=1107aad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107aad5",
  null
  
)

export default component.exports